import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from '../../utils/budget';

class CostModuleViewForm extends Component {
    // static PropTypes = {
    //     projectId: PropTypes.string.isRequired,
    //     objectCodeFMS: PropTypes.array.isRequired,
    //     costModules: PropTypes.array.isRequired,
    // }

    render() {
        const { objectCodeFMS, costModules } = this.props;

        objectCodeFMS.forEach(function (element) {
            element.classNameHeader = '';
        });

        objectCodeFMS.forEach(function (element) {
            if (element.wbSlevel2 === 'Design' && element.wbSlevel3 === 'Design Direct Labor')
                element.classNameHeader = 3;
            else if (element.wbSlevel2 === 'Construction' && element.wbSlevel3 === 'Construction Direct Labor')
                element.classNameHeader = 8;
            else
                element.classNameHeader = 0;
        });

        var totalEAC = 0;
        for (var i = 0; i < costModules.length; i++) {
            totalEAC += costModules[i].amountEAC;
        }

        var totalBaseline = 0;
        for (var c = 0; c < costModules.length; c++) {
            totalBaseline += costModules[c].amountBaseline;
        }

        console.log(costModules);
        
        return (
            <div id="costModule" className="row-wide">
                <div className="col s12">
                    <h4 className="bar-bottom">Cost Module</h4>
                </div>

                <div className="col s12" >
                    <div className="table-scroll">
                        <table className="td-table-border th-table-border table-striped">
                            <thead>
                                <tr>
                                    <th colSpan="3"></th>
                                    <th>Total Project Cost</th>
                                    <th colSpan='3'></th>
                                </tr>
                                <tr>
                                    <th>WBS (level 2)</th>
                                    <th>WBS (level 3)</th>
                                    <th>Associated FMS Object Code</th>
                                    <th>Estimate at Completion (EAC)</th>
                                    <th>FMS Actual</th>
                                    <th>FMS Plan (Funded Amt)</th>
                                    <th>Cost Baseline</th>
                                </tr>
                            </thead>

                            <tbody>

                                {objectCodeFMS.map((item, index) =>
                                    <tr key={item.id}>
                                        {item.classNameHeader === 0
                                            ? null
                                            : <th rowSpan={item.classNameHeader}>{item.wbSlevel2}</th>}
                                        <td>{item.wbSlevel3}</td>
                                        <td>{item.fmsObjectCode}</td>

                                        {costModules[index].amountEAC !== null && costModules[index].amountEAC !== ''
                                            ? <td> ${costModules[index].amountEAC.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
                                            : <td></td>}
                                        
                                        <td>{formatMoney(costModules[index].committedAmount)}</td>
                                        <td>{formatMoney(costModules[index].plannedAmount)}</td>

                                        {costModules[index].amountBaseline !== null && costModules[index].amountBaseline !== ''
                                            ? <td> ${costModules[index].amountBaseline.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
                                            : <td></td>}
                                    </tr>)}

                                <tr>
                                    <th>Total</th>
                                    <td colSpan="2"></td>
                                    <td>
                                        {formatMoney(totalEAC)}
                                    </td>
                                    <td>{formatMoney(this.props.totalFmsActual)}</td>
                                    <td>{formatMoney(this.props.totalFmsPlanned)}</td> 
                                    <td>
                                        {formatMoney(totalBaseline)}
                                    </td>
                                </tr> 

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

CostModuleViewForm.propTypes = {
    projectId: PropTypes.string.isRequired,
    objectCodeFMS: PropTypes.array.isRequired,
    costModules: PropTypes.array.isRequired
};

export default (CostModuleViewForm);